import { getLandingPageTemplatesApi } from '../utils/apis';

import { useQuery } from '@tanstack/react-query';

export const useTemplates = () => {
  const { data, isLoading } = useQuery({
    queryKey: ['landing-page-templates'],
    queryFn: getLandingPageTemplatesApi,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    gcTime: 1000 * 60 * 60,
    staleTime: Infinity,
  });

  return { data, isLoading };
};
